import { ColumnPlainObject } from './column.plainObject';
import { TransformPlainObject } from './transform.plainObject';

export class SourcePlainObject extends TransformPlainObject {
    public columns: ColumnPlainObject[] = [];
}
